import PropTypes from 'prop-types';
import clsx from 'clsx';
import Spacing from '@/components/Spacing';
import Container from '@/components/Container';
import Text from '@/components/Text';

const defaultProps = {
  color: 'text-green-500',
};

const propTypes = {
  heading: PropTypes.string.isRequired,
  color: PropTypes.string,
};

export default function SubHeading({
  heading,
  color,
}) {
  return (
    <Spacing bottom={4} inject>
      <Container padding={false}>
        <Text className={clsx('leading-none text-xl tracking-tight inline-flex font-semibold', color)}>
          {heading}
        </Text>
      </Container>
    </Spacing>
  );
}

SubHeading.defaultProps = defaultProps;
SubHeading.propTypes = propTypes;

